import type { CSRTimelinePoint } from '@/types/api';

const YEAR_IN_DAYS = 365;
const DAY_IN_MS = 24 * 60 * 60 * 1000;

export interface YearRangeOption {
  value: string;
  label: string;
  days?: number;
}

export function getMaxAvailableYears(timelines: Array<CSRTimelinePoint[] | undefined>): number {
  const earliestDateMs = timelines
    .flatMap((timeline) => (timeline ?? []).map((point) => new Date(point.date).getTime()))
    .reduce<number | null>((earliest, current) => (
      earliest == null || current < earliest ? current : earliest
    ), null);

  if (earliestDateMs == null) return 1;

  const spanDays = Math.max(1, Math.ceil((Date.now() - earliestDateMs) / DAY_IN_MS));
  return Math.max(1, Math.ceil(spanDays / YEAR_IN_DAYS));
}

export function buildYearRangeOptions(maxYears: number): YearRangeOption[] {
  const normalizedMaxYears = Math.max(1, maxYears);
  return [
    ...Array.from({ length: normalizedMaxYears }, (_, index) => {
      const years = index + 1;
      return {
        value: String(years),
        label: `${years}yr`,
        days: years * YEAR_IN_DAYS,
      };
    }),
    { value: 'all', label: 'All', days: undefined },
  ];
}

export function getSelectedYearRangeValue(days?: number): string {
  if (days == null) return 'all';
  if (days >= YEAR_IN_DAYS && days % YEAR_IN_DAYS === 0) {
    return String(days / YEAR_IN_DAYS);
  }
  return '';
}
